import React, { useEffect, useState } from 'react';
import { formatDate } from '@mysimpledb/shared/utils/formatDate';
import { createHandleListClick } from '@mysimpledb/shared/hooks/useUserData';
import {
  handleNextPage,
  handlePrevPage,
} from '@mysimpledb/shared/hooks/usePaginationHelpers';
// ✅ NEW: use the same helper you use elsewhere for avatars
import { buildAvatarUrl } from '@mysimpledb/shared/utils/mediaUrls';
import SharedPublicProfileModal from '../Account/SharedPublicProfileModal';
import AppButton from '@mysimpledb/shared/components/UI/Button/Button';
import paperPencilIcon from '../../assets/images/paper-pencil-icon.png';

import './ListDataWeb.css';

export default function ListDataWeb({
  currentIndex,
  entries,
  fetchPage,
  listPageClicked,
  listPageNo,
  onNewEntry,
  setActiveTab,
  setCurrentEntryId,
  setCurrentIndex,
  setEntryPageNo,
  setForm,
  setListPageClicked,
  setListPageNo,
  setNavSource,
  token,
  totalEntriesFound,
  usersSharingMap,
  userId,
}) {
  const [publicProfileUserId, setPublicProfileUserId] = useState(null);

  const handleListClick = createHandleListClick({
    entries,
    setCurrentIndex,
    setCurrentEntryId,
    setForm,
    token,
    setActiveTab, // optional for mobile
    listPageNo,
    listPageClicked,
    setListPageClicked,
  });

  useEffect(() => {
    console.log('usersSharingMap for user', userId, usersSharingMap);
  }, [userId, usersSharingMap]);

  return (
    <div className="list-outer-wrapper">
      <button
        className="nav-arrow left"
        onClick={() => handlePrevPage(listPageNo, setListPageNo, fetchPage)}
        disabled={listPageNo === 0}
      >
        &larr;
      </button>

      <form className="userdata-form">
        <div className="tab-content">
          <div className="list-toolbar">
            <button
              type="button"
              className="new-entry-button"
              onClick={onNewEntry}
            >
              <img src={paperPencilIcon} alt="" className="new-entry-icon" />
              <span>New Entry</span>
            </button>
          </div>
          <div className="list-header">
            <span className="list-col category">Category</span>
            <span className="list-col title heading">Title</span>
            <span className="list-col updated-at heading">Updated</span>
            <span className="list-col shared-title">Shared By</span>
            <span className="list-col"></span>
          </div>

          {entries.map((entry, index) => {
            // Is the logged-in user the owner of this entry?
            const isOwner = Number(entry.user_id) === Number(userId);

            const isSelected =
              entry.id === entries[currentIndex]?.id &&
              listPageClicked === listPageNo;

            // 1) Prefer usersSharingMap[entry.user_id] if it exists
            const mapMeta =
              !isOwner && usersSharingMap
                ? usersSharingMap[entry.user_id]
                : undefined;

            // 2) Fallback to data on the entry itself if mapMeta is missing
            const fallbackMeta = !isOwner
              ? {
                  shared_name: entry.shared_name,
                  share_profile_picture: entry.share_profile_picture,
                  profile_picture: entry.profile_picture,
                }
              : null;

            const meta = mapMeta || fallbackMeta || {};

            const sharedName =
              !isOwner && meta.shared_name ? meta.shared_name : '';

            const shouldShowPic =
              !isOwner &&
              !!meta.share_profile_picture &&
              !!meta.profile_picture;

            const avatarUrl = shouldShowPic
              ? buildAvatarUrl(meta.profile_picture)
              : null;

            return (
              <div
                key={entry.id}
                className={`list-item ${isSelected ? 'selected' : ''}`}
                onClick={() => {
                  setEntryPageNo(listPageNo);
                  setNavSource('list');
                  handleListClick(entry.id);
                }}
              >
                <div className="dot-wrapper">
                  {entry.id === entries[currentIndex]?.id &&
                    listPageClicked === listPageNo && (
                      <span className="entry-dot" />
                    )}
                </div>

                <span className="list-col category item">{entry.category}</span>
                <span className="list-col title item">{entry.title}</span>
                <span className="list-col updated-at item">
                  {formatDate(entry.updated_at)}
                </span>

                {/* Shared name */}
                <span className="list-col shared-name">
                  {sharedName && (
                    <button
                      type="button"
                      className="shared-profile-name-button"
                      onClick={(event) => {
                        event.stopPropagation();
                        setPublicProfileUserId(entry.user_id);
                      }}
                    >
                      {sharedName}
                    </button>
                  )}
                </span>

                {/* Shared avatar */}
                <span className="list-col profile-picture">
                  {!isOwner && (
                    <button
                      type="button"
                      className="shared-profile-avatar-button"
                      aria-label={`View ${sharedName || 'user'} public profile`}
                      onClick={(event) => {
                        event.stopPropagation();
                        setPublicProfileUserId(entry.user_id);
                      }}
                    >
                      {avatarUrl ? (
                        <img
                          src={avatarUrl}
                          alt=""
                          className="shared-profile-pic"
                        />
                      ) : (
                        <span className="shared-profile-pic-placeholder" />
                      )}
                    </button>
                  )}
                </span>
              </div>
            );
          })}
        </div>
      </form>

      <button
        className="nav-arrow right"
        onClick={() => handleNextPage(listPageNo, setListPageNo, fetchPage)}
        disabled={listPageNo + 1 === Math.ceil(totalEntriesFound / 30)}
      >
        &rarr;
      </button>

      <span className="entry-counter">
        {totalEntriesFound > 0
          ? `${listPageNo + 1} of ${Math.ceil(totalEntriesFound / 30)}`
          : '0 of 0'}
      </span>

      {publicProfileUserId && (
        <SharedPublicProfileModal
          userId={publicProfileUserId}
          token={token}
          onClose={() => setPublicProfileUserId(null)}
        />
      )}
    </div>
  );
}
